import { InternalNote } from '../state/types'
import { showErrorStrToast } from '../../../features/ui'

export const useAddNote = <T extends { internalNotes?: InternalNote[] }>(
    entity: T,
    save: (updated: T) => Promise<void>
) => {
    const addNote = async (text: string) => {
        const newNote: InternalNote = {
            text,
            date: new Date().toISOString()
        }
        const updatedInternalNotes = [newNote, ...entity.internalNotes ?? []]
        try {
            await save({ ...entity, internalNotes: updatedInternalNotes })
        } catch (error) {
            showErrorStrToast('Error al guardar la nota.')
        }
    }
    return addNote
}
